import { Link, Translation } from '@ps/web-shared-components';
import { required } from '@ps/web-shared-validators';
import React from 'react';
import { Field } from 'react-final-form';

import useValidator from '@swf/core/hooks/useValidator';

import Checkbox from '../../../../../Checkbox/Checkbox';

import { TXTWCL_I_acknowledge_I_have_read_and__ELL } from './PlayerFundsProtection.messages.json';

export const playerFundsProtection = 'playerFundsProtection';

interface Props {
  onPFPClick?: () => void;
}

const PlayerFundsProtection: React.FC<Props> = ({ onPFPClick }) => {
  const [validator] = useValidator(required());

  return (
    <Field name={playerFundsProtection} initialValue={false} type="checkbox" validate={validator}>
      {({ input: { onChange, checked }, meta }) => (
        <Checkbox
          meta={meta}
          name={playerFundsProtection}
          checked={checked}
          onChange={onChange}
          label={
            <Translation
              {...TXTWCL_I_acknowledge_I_have_read_and__ELL}
              values={{
                a: (msg: string) => (
                  <Link
                    onClick={(e: React.MouseEvent) => {
                      e.preventDefault();
                      onPFPClick?.();
                    }}
                  >
                    {msg}
                  </Link>
                )
              }}
            />
          }
        />
      )}
    </Field>
  );
};

export default PlayerFundsProtection;
